import script from "./AdminSensitiveWords.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSensitiveWords.vue?vue&type=script&setup=true&lang=js"

import "./AdminSensitiveWords.vue?vue&type=style&index=0&id=17de735d&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17de735d"]])

export default __exports__